// THIS CANNOT BE CHANGED WILLY NILLY UNLESS WE START STORING IT ON EACH SPLIT IN THE DB
export const SPLITS_DISTRIBUTOR_FEE_PERCENT: number = 1
